import { get, isArray, isEmpty } from 'lodash'
import { ChangeEvent, FC, ReactElement, useCallback } from 'react'
import { Field, Form } from '../input'
import { Container } from './style'

type FileInputProps = {
  label?: string;
  form?: Form;
  field?: Field;
  accept?: string;
  isMulti?: boolean;
  name?: string;
  value?: File | File[];
}

const FileInput: FC<FileInputProps> = ({ isMulti, accept, field, form, label, name: _name, value: _value }): ReactElement => {
  const name = field?.name || _name || ''
  const value = field?.value || _value

  const errorMessage = name ? get(form?.errors, name) : null
  const touched = name ? get(form?.touched, name) : null
  const error = touched && errorMessage

  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (field && field.onBlur) {
      field.onBlur(e)
    }

    if (form && e.target.files) {
      const listing = []

      for (let i = 0; i < e.target.files.length; i++) {
        listing.push(e.target.files[i])
      }

      form.setFieldValue(name, listing)
    }
  }, [name, form, field])

  return (
    <Container $error={!!error}>
      {label && <label>{label}</label>}
      <div className='input_file_content'>
        <span>Solte o arquivo aqui ou selecione</span>
        <input
          name={name}
          accept={accept}
          multiple={isMulti}
          type='file'
          onChange={onChange}
        />
        {isArray(value) && value.length > 0
          ? (
            <span className='select' title={value.map(d => d.name).join(', ')}>Arquivos: {value.map(d => d.name).join(', ')}</span>
          )
          : isEmpty(value) === false && (
            <span className='select'>Arquivo: {value?.name}</span>
          )}
      </div>
      {error && <span className='error'>{error}</span>}
    </Container>
  )
}

export default FileInput
